module.exports = fox._r("components/valentines-gifts-popup/images/default/text.png", __webpack_public_path__ + "_/_/_/root/components/valentines-gifts-popup/images/default/text.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/valentines-gifts-popup/images/default/text.png
// module id = 730
// module chunks = 4